<div class="wrapper-gallery">
	<div class="section-title">
		<div class="row">
			<div class="col-12 col-md">
				<div class="d-flex align-items-center">
					<div class="title">{{ "Media Library" | translate }}</div>
				</div>
			</div>
			<div class="col-12 col-md-auto text-md-right mt-3 mt-md-0 header-actions">
				<button
					class="btn btn-select mr-2 ui-classic-only"
					*ngIf="!selectionMode && mediaData.length"
					(click)="toggleSelectionMode()"
				>
					{{ "Select" | translate }}
				</button>
				<button
					class="btn btn-primary ui-classic-only"
					routerLink="/dashboard/create-media"
				>
					{{ "Create Media" | translate }}
				</button>
			</div>
		</div>
	</div>

    <div class="section-main" [class.selecting]="selectionMode">
        <div class="gallery-toolbar mb-4">
            <div class="filter-options">
                <button type="button" class="btn btn-filter" [class.active]="filterType === 'all'" (click)="setFilterType('all')">
                    <i class="fi fi-rr-grid mr-1"></i>
                    <span>{{ "All" | translate }}</span>
                </button>
                <button type="button" class="btn btn-filter" [class.active]="filterType === 'image'" (click)="setFilterType('image')">
                    <i class="fas fa-image mr-1"></i>
                    <span>{{ "Images" | translate }}</span>
                </button>
                <button type="button" class="btn btn-filter" [class.active]="filterType === 'video'" (click)="setFilterType('video')">
                    <i class="fi fi-rr-play-alt mr-1"></i>
                    <span>{{ "Videos" | translate }}</span>
                </button>
            </div>
            
            <!-- Search, and (glass theme) Select + Create Media on its right -->
            <div class="toolbar-end">
                <div class="search-box">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="{{ 'Search by name...' | translate }}"
                        [(ngModel)]="searchTerm"
                        (ngModelChange)="filterMedias()"
                    />
                    <i class="fi fi-rr-search search-icon"></i>
                    <i class="fas fa-times clear-icon" *ngIf="searchTerm" (click)="clearSearch()"></i>
                </div>
                <button
                    class="btn btn-select ui-glass-only"
                    *ngIf="!selectionMode && mediaData.length"
                    (click)="toggleSelectionMode()"
                >
                    {{ "Select" | translate }}
                </button>
                <button
                    class="btn btn-primary ui-glass-only toolbar-create-btn"
                    routerLink="/dashboard/create-media"
                >
                    {{ "Create Media" | translate }}
                </button>
            </div>
        </div>
        <div class="selection-bar" *ngIf="selectionMode">
            <label class="select-all">
                <input type="checkbox" [checked]="allOnPageSelected" (change)="toggleSelectAllPage()">
                <span>{{ "Select all on this page" | translate }}</span>
            </label>
            <span class="selected-count">{{ selectedIds.size }} {{ "selected" | translate }}</span>
            <span class="spacer"></span>
            <button class="btn btn-delete" [disabled]="selectedIds.size === 0 || deleting" (click)="confirmDeleteSelected()">
                {{ (deleting ? "Deleting..." : "Delete") | translate }}<span *ngIf="selectedIds.size && !deleting"> ({{ selectedIds.size }})</span>
            </button>
            <button class="btn btn-cancel" [disabled]="deleting" (click)="cancelSelection()">{{ "Cancel" | translate }}</button>
        </div>
        <div class="row">
            <div class="col-12">

                <div *ngIf="mediaData.length == 0 && !loading" class="text-center">
                    <div class="pb-4 text-center no-records">{{ "No Record found" | translate }}</div>
                </div>
                <div *ngIf="loading" class="text-center">
                    <div class="loading-spinner col-12 mt-5">
                        <mat-spinner class="mx-auto my-t" [diameter]="50"></mat-spinner>
                    </div>
                </div>

                <div class="gallery-media-container" *ngIf="!loading">
                    <div class="gallery-media-item" *ngFor="let media of mediaData"
                        [attr.data-media-id]="media.media_id"
                        [class.selectable]="selectionMode"
                        [class.selected]="isSelected(media)"
                        (click)="onCardClick(content, media)">
                        <div class="select-check" *ngIf="selectionMode">
                            <input type="checkbox" [checked]="isSelected(media)" tabindex="-1">
                        </div>
                        <div class="gallery-media-thumbnail-container row">
                            <div class="col text-center">
                                <video *ngIf="isVideo(media.photo)" class="img-thumbnail checkered-bg" [src]="media.photo" muted playsinline></video>
                                <img *ngIf="!isVideo(media.photo)" class="img-thumbnail checkered-bg" [src]="media.photo" [alt]="media.photo"
                                    (error)="setErrorImg($event, media.media_id)" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="media-name">{{media.title || "Media ID: " + media.media_id}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="mediaData.length != 0 && !loading" class="row px-4 py-3 pagination">
                    <div class="col-lg-4 flex">
                        <ngb-pagination
                            [collectionSize]="medias.length" [(page)]="page" [pageSize]="selectedPage"
                            aria-label="Default pagination" (pageChange)="changePage($event)"
                            [ellipses]="false" [rotate]="true" [maxSize]="5"></ngb-pagination>
                    </div>
                    <div class="col-lg-4 lg-center paginationWrapper">
                        <div class="mt-2 text-center">{{ "Showing" | translate }} <b>{{ start + 1 }}–{{ end }}</b> {{ "of" | translate }} <b>{{ medias.length }}</b></div>
                    </div>
                    <div class="col-lg-4 per-page">
                        <span>{{ "Per page:" | translate }}</span>
                        <div ngbDropdown class="d-inline-block">
                            <button class="btn btn-page" id="dropdownBasic1" ngbDropdownToggle>{{ selectedPage }}</button>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                <button ngbDropdownItem (click)="selectPage(25)">25</button>
                                <button ngbDropdownItem (click)="selectPage(50)">50</button>
                                <button ngbDropdownItem (click)="selectPage(75)">75</button>
                                <button ngbDropdownItem (click)="selectPage(100)">100</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="table-history table-responsive mx-auto">
            <table class="table">
                <thead>
                    <tr>
                        <th class="border-left-0 text-start w-150" scope="col">
                            Title
                        </th>
                        <th class="border-left-0 text-start w-150" scope="col">
                            Caption
                        </th>
                        <th class="border-left-0 text-start w-150" scope="col">
                            Photo
                        </th>
                        <th class="border-left-0 text-center" scope="col">
                            Time Created
                        </th>
                        <th class="border-right-0 text-center" scope="col">
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody *ngFor="let media of mediaData ; let index=index">
                    <tr>
                        <td class="border-left-0 text-start">{{ media.title }}</td>
                        <td class="text-start">{{ media.caption }}</td>
                        <td class="text-start"><img height="200px" width="auto" src="{{ media.photo }}" alt=""></td>
                        <td class="text-center">{{ media.created_at }}</td>
                        <td class="border-right-0 text-center">
                            <button mat-button [matMenuTriggerFor]="menu" class="btn btn-action">
                                Action
                            </button>
                            <mat-menu #menu="matMenu" class="menu-1">
                                <button mat-menu-item (click)="openModal(content)" (click)="getMediaList(media.store_id, media.media_id, media.title, media.alt_text, media.caption, media.filesize, media.photo)">Update</button>
                                <button mat-menu-item (click)="removeMedia(media.store_id,media.media_id)">Delete</button>
                            </mat-menu>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>-->

    </div>
</div>

<ng-template #content let-modal>
    <div class="image-details">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">{{ "Image Details" | translate }}</h4>
            <button type="button" class="close-btn" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <form [formGroup]="mediaForm" (ngSubmit)="updateMedia()" method="post">
            <div class="modal-body">
                <div class="details-grid">
                    <!-- Preview -->
                    <div class="preview-box">
                        <video *ngIf="isVideo(photo)" [src]="photo" controls style="max-width: 100%; max-height: 100%; object-fit: contain;"></video>
                        <img *ngIf="!isVideo(photo)" [src]="photo"
                            onerror="this.onerror=null;this.src='https://cdn.estore5s.com/asset/images/estore_missing_product.png';">
                    </div>

                    <!-- Fields -->
                    <div class="fields">
                        <div class="field">
                            <label>{{ "Title" | translate }}</label>
                            <input class="form-control" formControlName="title" type="text">
                        </div>
                        <div class="field">
                            <label>{{ "Caption" | translate }}</label>
                            <input class="form-control" formControlName="caption" type="text">
                        </div>
                        <div class="field">
                            <label>{{ "Alt Text" | translate }}</label>
                            <input class="form-control" formControlName="alt_text" type="text">
                        </div>
                        <div class="field">
                            <label>{{ "URL" | translate }}</label>
                            <div class="url-row">
                                <input class="form-control" formControlName="url" type="text" readonly>
                                <button type="button" class="btn-copy" [openDelay]="300" [closeDelay]="500"
                                    ngbTooltip="{{ 'Copy link' | translate }}" (click)="copyUrl(photo)">
                                    <i class="fi-rr-copy-alt"></i> {{ "Copy" | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn-ghost-danger" (click)="removeMedia(store_id, media_id)"
                    (click)="modal.close('Close click')">
                    <i class="fi-rr-trash"></i> {{ "Delete" | translate }}
                </button>
                <div class="footer-right">
                    <button type="button" class="btn-ghost" (click)="modal.dismiss('Cancel click')">{{ "Cancel" | translate }}</button>
                    <button type="submit" class="btn-primary-solid">{{ "Update" | translate }}</button>
                </div>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #uploade let-modal>
    <div class="uplode-popup">
        <div class="uploade-header p-3 border-bottom">
            <h2 class="mb-0">Upload Image</h2>
            <button type="button" class="close text-primary" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <i class="fas fa-times"></i>
            </button>
        </div>
        <div class="uploade-body px-0 m-1 pb-0">
            <div class="section main">
                <div class="container col mb-4 mx-0">
                    <mat-tab-group animationDuration="0ms" [disableRipple]="true" dynamicHeight>
                        <mat-tab label="Upload Image">
                            <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="onSelect($event)">
                                <ngx-dropzone-label>
                                    <div>
                                        <h2>Select your file or Drop it</h2>
                                    </div>
                                </ngx-dropzone-label>
                                <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files"
                                    [file]="f" [removable]="true" (removed)="onRemove(f)">
                                </ngx-dropzone-image-preview>
                            </div>
                        </mat-tab>
                        <mat-tab label="Choose from gallery">
                            <div class="">
                                <div class=" mb-3">
                                    <video *ngIf="photo && isVideo(photo)" [src]="photo" controls style="width: 300px; max-height: 300px; object-fit: contain;"></video>
                                    <img *ngIf="photo && !isVideo(photo)" [src]="photo" class="image-uploaded "
                                        style="width: 300px;">
                                </div>
                                <div class="row mt-3">
                                    <div class="col-3" *ngFor="let media of allMedias">
                                        <div (click)="imageSelect(media.photo)" class="card mb-2">
                                            <video *ngIf="isVideo(media.photo)" height="200px" width="100%" style="object-fit: contain;" [src]="media.photo" muted playsinline></video>
                                            <img *ngIf="!isVideo(media.photo)" height="200px" width="auto" [src]="media.photo">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </div>
        </div>

        <div class="uploade-footer">
            <div align="right" class="mt-2 mr-4 mb-3">
                <div mat-button class="btn btn-action --single cancel" (click)="modal.dismiss('Cross click')">Cancel
                </div>
                <div mat-button class="btn btn-action --single ml-2" (click)="modal.dismiss('Cross click')">Save</div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #success let-modal>
    <div class="modal-body text-center">
        <div class="row" align="center">
            <div class="col pt-4 pt-lg-0">
                <h4>Successfully Update</h4>
            </div>
        </div>
        <button class="btn btn-primary" type="button" name="button" (click)="modal.close('Send click')  ">Close</button>
    </div>
</ng-template>

<ng-template #fail let-modal>
    <div class="modal-body text-center">
        <div class="row" align="center">
            <div class="col">
                <h4>{{errorMsg}}</h4>
            </div>
        </div>
        <button class="btn btn-danger" type="button" name="button" (click)="modal.close('Send click')  ">Close</button>
    </div>
</ng-template>
